var _mask, _path, _path2, _mask2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_205:212",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2726 15.2727V43.6363C41.2726 44.7937 40.8128 45.9036 39.9945 46.7219C39.1761 47.5402 38.0662 48 36.9089 48H12.9089C11.7516 48 10.6417 47.5402 9.82337 46.7219C9.00503 45.9036 8.54529 44.7937 8.54529 43.6363V15.2727"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2726 15.2727V12.2727H38.2726V15.2727H44.2726ZM8.54529 43.6363H5.54529H8.54529ZM11.5453 15.2727V12.2727H5.54529V15.2727H11.5453ZM38.2726 15.2727V43.6363H44.2726V15.2727H38.2726ZM38.2726 43.6363C38.2726 43.998 38.1289 44.3448 37.8732 44.6006L42.1158 48.8432C43.4967 47.4623 44.2726 45.5893 44.2726 43.6363H38.2726ZM37.8732 44.6006C37.6174 44.8563 37.2706 45 36.9089 45V51C38.8619 51 40.7349 50.2242 42.1158 48.8432L37.8732 44.6006ZM36.9089 45H12.9089V51H36.9089V45ZM12.9089 45C12.5473 45 12.2004 44.8563 11.9447 44.6006L7.70205 48.8432C9.083 50.2242 10.956 51 12.9089 51V45ZM11.9447 44.6006C11.689 44.3448 11.5453 43.998 11.5453 43.6363H5.54529C5.54529 45.5893 6.3211 47.4623 7.70205 48.8432L11.9447 44.6006ZM11.5453 43.6363V15.2727H5.54529V43.6363H11.5453Z",
    fill: "#EB116B",
    mask: "url(#path-1-inside-1_205:212)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.72729H47.8182",
    stroke: "#EB116B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_205:212",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2728 8.72727V0H32.5456V8.72727"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2728 8.72727V11.7273H20.2728V8.72727H14.2728ZM17.2728 0V-3H14.2728V0H17.2728ZM32.5456 0H35.5456V-3H32.5456V0ZM29.5456 8.72727V11.7273H35.5456V8.72727H29.5456ZM20.2728 8.72727V0H14.2728V8.72727H20.2728ZM17.2728 3H32.5456V-3H17.2728V3ZM29.5456 0V8.72727H35.5456V0H29.5456Z",
    fill: "#EB116B",
    mask: "url(#path-4-inside-2_205:212)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4547 23.9683L18.3638 37.0592",
    stroke: "#EB116B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4547 37.0592L18.3638 23.9683",
    stroke: "#EB116B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/icon_remove.a7dbe26c.svg";
export { ForwardRef as ReactComponent };